import { LanguageSwitcherApi } from "../../../redux/api";
import { LanuageSwitchActionCreators } from "../../../redux/action-creators";

export const getLanguageSwitcherData = async (
  urlPath,
  publicationId,
  mainPage,
  dispatch
) => {
  const languageData = await LanguageSwitcherApi.languageData(
    urlPath,
    publicationId,
    mainPage
  );

  if (languageData?.response) {
    dispatch(LanuageSwitchActionCreators.setData(languageData?.response));
  } else if (languageData?.errorResponse) {
    console.error(
      `There is an error in API call. ${JSON.stringify(languageData?.errorResponse)}`
    );
  }
};
